module.exports = __webpack_public_path__ + "img/notice-bj.47b14580.png";